import { authenticatedFetch } from './apiUtils';
import { getApiUrl } from '../config';

const API_URL = getApiUrl();

export async function login(email: string, password: string): Promise<{ token: string }> {
  const res = await fetch(`${API_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  });
  if (!res.ok) throw new Error((await res.json()).message || 'Login failed');
  return res.json();
}

export async function register(email: string, password: string, registrationToken: string): Promise<{ token: string }> {
  const res = await fetch(`${API_URL}/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, registrationToken })
  });
  if (!res.ok) throw new Error((await res.json()).message || 'Registration failed');
  return res.json();
}

export async function validateToken(): Promise<boolean> {
  const token = localStorage.getItem('token');
  if (!token) return false;

  try {
    const res = await authenticatedFetch(`${API_URL}/auth/validate`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    return res.ok;
  } catch (error) {
    return false;
  }
} 